import React, { Fragment } from "react";
import styled from "styled-components";
import I10n from '../../features/i10n';
import MsxIcons from '../../features/msx-icons';
import PropTypes from 'prop-types';
import ProductLink from "../product_link";
import ProductInformationCache from '../../persistence/description-cache';

const TableLicenceGroupTitle = styled.tr``;

const TableLicenceGroupTitleCell = styled.td`
  background-color: white;
  color: #000000;
  padding: 0px;
  border-top: 1px solid #D9D9D9;
  border-left: 1px solid #D9D9D9;
  border-right: 1px solid #D9D9D9;
  vertical-align: middle;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;

  ${props => props.hideRow ? `
    border-bottom: 1px solid #D9D9D9;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  ` : ``}
  overflow: hidden;
`;

const TableLicenceGroupHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  margin-left: 10px;
  font-weight: 700;
  cursor: pointer;
`;

const TableHeaderCell = styled.td`
  background-color: #F3F3F3;
  color: #626469;
  font-weight: 400;
  font-size: 12px;
  padding: 0px;
  vertical-align: middle;

  :first-of-type {
    border-left: 1px solid #D9D9D9;
  }

  :last-of-type {
    border-right: 1px solid #D9D9D9;
  }
`;

const DescriptionTableHeaderCell = styled(TableHeaderCell)`
  @media (max-width: 450px) {
    display: none;
  }
`;

const NumberHeaderCell = styled(TableHeaderCell)`
  text-align: center;
`;

const TableCell = styled.td`
  padding: 0px;
  vertical-align: middle;

  background-color: white;

  :first-of-type {
    border-left: 1px solid #D9D9D9;
    ${props => props.fromLastRow ? `border-bottom-left-radius: 8px;` : ``}
  }

  :last-of-type {
    border-right: 1px solid #D9D9D9;
    ${props => props.fromLastRow ? `border-bottom-right-radius: 8px;` : ``}
  }

  ${props => props.fromLastRow ? `border-bottom: 1px solid #D9D9D9;` : ``}
`;

const CellContent = styled.div`
  padding: 10px;
  ${props => props.hideCell ? `padding: 0px 10px; height: 0px` : ``}
`;

const NumberCell = styled(TableCell)`
  font-size: 14px;
  text-align: center;
`;

const TableRow = styled.tr`
  ${props => props.hideRow ? 'visibility: hidden;' : 'border-bottom: 1px solid #D9D9D9;'}
`;

const TableHeaderRow = styled.tr`
  ${props => props.hideRow ? 'visibility: hidden;' : ''}
`;

const ArrowIconWrapper = styled.div`
  user-select: unset;
  transition: transform 0.3s;
  transform: ${props => props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: content-box;
  min-width: 32px;
  width: 32px;
  max-width: 32px;
  height: 32px;
`;

const IndexLabel = styled.span``;

const ServicePlanDescriptionLabel = styled.span`

  font-style: normal;
  color: #626469;
  font-size: 12px;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;

`;

const DescriptionCell = styled(TableCell)`
  position: relative;
  width: 100%;
  @media (max-width: 450px) {
    display: none;
  }
`;

const ServicePlanDescriptionCellContent = styled(CellContent)`
  position: absolute;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
`;



const ProductLinkWrapper = styled.div`
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 12px;
`;


class BomServicePlanGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: true,
    }
  }

  static propTypes = {
    servicePlanItems: PropTypes.array,
    servicePlanActivated: PropTypes.bool,
    setServicePlanActivation: PropTypes.func,
    startIdx: PropTypes.number,
    isSaving: PropTypes.bool
  }

  renderServicePlanItemRow = (servicePlanItem, index, hideRow, isLastRow) => {

    return (
      <TableRow hideRow={hideRow}>
        <NumberCell fromLastRow={isLastRow}><CellContent hideCell={hideRow}><IndexLabel>{index}</IndexLabel></CellContent></NumberCell>
        <TableCell fromLastRow={isLastRow}>
          <CellContent hideCell={hideRow}>
            <ProductLinkWrapper>
              <ProductLink reference={servicePlanItem.id} disabled={true}></ProductLink>
            </ProductLinkWrapper>
          </CellContent>
        </TableCell>
        <DescriptionCell fromLastRow={isLastRow} title={ProductInformationCache.getDescription(servicePlanItem.id) || servicePlanItem.description}>
          <ServicePlanDescriptionCellContent hideCell={hideRow}>
            <ServicePlanDescriptionLabel>{ProductInformationCache.getDescription(servicePlanItem.id) || servicePlanItem.description}</ServicePlanDescriptionLabel>
          </ServicePlanDescriptionCellContent>
        </DescriptionCell>
        <TableCell fromLastRow={isLastRow}><CellContent hideCell={hideRow}>{servicePlanItem.quantity}</CellContent></TableCell>
        <TableCell fromLastRow={isLastRow}>
        </TableCell>
      </TableRow>
    );
  };

  render = () => {
    const hideRow = !this.state.isOpen;
    return (
      <Fragment>
       <TableLicenceGroupTitle onClick={() => { this.setState({isOpen: !this.state.isOpen}); }}>
        <TableLicenceGroupTitleCell hideRow={hideRow} colSpan={5}>
        <TableLicenceGroupHeader>
          {I10n.get(`bom.licence.licencegroup.name.service_plan`)}
          <ArrowIconWrapper isOpen={this.state.isOpen}>
            <MsxIcons name="down-arrow" size="nano"></MsxIcons>
          </ArrowIconWrapper>
        </TableLicenceGroupHeader>
       </TableLicenceGroupTitleCell>
      </TableLicenceGroupTitle>
          <>
            <TableHeaderRow hideRow={hideRow}>
              <NumberHeaderCell><CellContent hideCell={hideRow}>{I10n.get('bom.order')}</CellContent></NumberHeaderCell>
              <TableHeaderCell><CellContent hideCell={hideRow}>{I10n.get('bom.reference')}</CellContent></TableHeaderCell>
              <DescriptionTableHeaderCell><CellContent hideCell={hideRow}>{I10n.get('bom.description')}</CellContent></DescriptionTableHeaderCell>
              <TableHeaderCell colSpan={2}><CellContent hideCell={hideRow}>{I10n.get('bom.service_plan_size')}</CellContent></TableHeaderCell>
            </TableHeaderRow>
            {this.props.servicePlanItems.map((licence, idx)  => (<Fragment key={idx}>{this.renderServicePlanItemRow(licence, this.props.startIdx + idx, hideRow, this.props.servicePlanItems.length === (idx + 1))}</Fragment>))}
          </>
      </Fragment>

    );
  }
}

export default BomServicePlanGroup;
